<template>
    <div class="container-fluid default-dashboard">
        <div class="row widget-grid">
            <TableListProduct @update:filterStatus="onStatusFilterChange" @download="download_csv"/>
            <FormListProduct v-model="listProduct" :listStatus="listStatus"/>
        </div>
    </div>
</template>
<script setup>
import { ref, defineAsyncComponent, onMounted , watch } from 'vue'
const TableListProduct = defineAsyncComponent(() => import("@/components/theme/product-planner/TableListProduct.vue"))
const FormListProduct = defineAsyncComponent(() => import("@/components/theme/product-planner/FormListProduct.vue"))

import { directus } from '@/services/directus';
import { readItems } from '@directus/sdk';
import axios from 'axios';

const pdkmake_ip = process.env.VUE_APP_PDFMAKE_URL && process.env.VUE_APP_PDFMAKE_URL.startsWith("http")
    ? process.env.VUE_APP_PDFMAKE_URL
    : 'http://localhost:3001';

const listProduct = ref([])
const listStatus = ref({ status: [] });

function onStatusFilterChange(statusList) {
    listStatus.value = statusList;
}

async function fetchProductList() {
    // 1. ดึงสินค้า
    const products = await directus.request(
        readItems("product", {
            fields: ["product_name", "device", "brand", "model", "min_threshold", "delivery_duration", "product_code", "count", "id", "sell"],
            limit: -1,
        })
    );

    const productCodes = products
        .map(p => p.product_code)
        .filter(code => !!code); // กรอง null/undefined

    // 2. ดึง stock ทีเดียว โดยกรองเฉพาะ product_code_office_design ที่เกี่ยวข้อง
    const stockItems = await directus.request(
        readItems("stock", {
            fields: ["product_code_office_design","stock_id"],
            limit: -1,
            filter: {
                product_code_office_design: {
                    _in: productCodes
                },
                status: {
                    _in: ['รอตรวจสอบอุปกรณ์','พร้อมใช้งาน','รอเช็คก่อนส่ง']
                },
                device_status: {
                    _eq: 'สินค้าขาย'
                }
            }
        })
    );

    const product_planner = await directus.request(
        readItems("installation_plan_products", {
            fields: [
                "product_code",
                "quantity",
                "installation_plan.id",
                "installation_plan.company_name",
                "installation_plan.store_name",
                "installation_plan.branch_code",
                "installation_plan.branch_name",
                "installation_plan.created_at",
                "installation_plan.status",
                "installation_plan.installation_plan_products.*"
            ],
            limit: -1,
            filter: {
                product_code: {
                    _in: productCodes
                },
                installation_plan: {
                    status: {
                        _in: ['pending']
                    }
                }
            }
        })
    );

    // 3. นับจำนวน stock ต่อ product_code
    const stockCountMap = {};
    const orderCountMap = {}; 

    for (const stock of stockItems) {
        const code = stock.product_code_office_design;
        stockCountMap[code] = (stockCountMap[code] || 0) + 1;
        if (stock.stock_id) {
            orderCountMap[code] = (orderCountMap[code] || 0) + 1;
        }
    }

    // 4. ใส่ค่า qulitty ให้แต่ละสินค้า และรวม installation_plan
    const groupedByDevice = {};
    for (const item of products) {
        const code = item.product_code;

        item.quality = stockCountMap[code] || 0;
        item.in_order = orderCountMap[code] || 0;
        item.planner_count = 0; // default เป็น 0

        // คำนวณจำนวนจาก installation_plan_products
        const plannerItems = product_planner.filter(p => p.product_code === code);
        const totalPlannerQuantity = plannerItems.reduce((sum, p) => sum + (p.quantity || 0), 0);

        item.planner_count = totalPlannerQuantity;

        // รวม installation_plan.* ทั้งหมดที่เกี่ยวข้องกับ product_code นี้
        item.installation_plans = plannerItems.map(p => p.installation_plan);

        if (!groupedByDevice[item.device]) {
            groupedByDevice[item.device] = [];
        }
        groupedByDevice[item.device].push(item);
    }

    listProduct.value = groupedByDevice;   
}

onMounted(() => {
    fetchProductList()
})

async function download_csv(filteredDevices) {
    // ถ้าไม่ได้ส่ง filter มา ให้ fallback เป็นทั้งหมด
    const devices = filteredDevices && filteredDevices.length > 0
        ? filteredDevices
        : Object.keys(listProduct.value);

    const formatted = {};
    for (const device of devices) {
        if (listProduct.value[device]) {
            formatted[device] = listProduct.value[device].map(item => {
                const { installation_plans, ...rest } = item;
                return rest;
            });
        }
    }
    // ...ส่วนที่เหลือเหมือนเดิม...
    const now = new Date();
    const pad = n => n.toString().padStart(2, '0');
    const fileName = `product-list_${now.getFullYear()}${pad(now.getMonth()+1)}${pad(now.getDate())}_${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}`;

    const payload = {
        fileName: fileName,
        data: formatted,
    };

    const response = await axios.post(`${pdkmake_ip}/excel/product_list`, payload, {
        responseType: 'blob',
        headers: {
            'Content-Type': 'application/json'
        }
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${fileName}.xlsx`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
}
</script>